(() => {
  if (customElements.get('product-modal')) return;

  function defineProductModal() {
    if (customElements.get('product-modal')) return;

    const BaseModalDialog =
      typeof ModalDialog !== 'undefined'
        ? ModalDialog
        : customElements.get('modal-dialog');

    if (!BaseModalDialog) return;

    class ProductModal extends BaseModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        if (!this.openedBy) return;

        const mediaId = this.openedBy.getAttribute('data-media-id');
        if (!mediaId) return;

        this.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.toggle(
            'active',
            element.getAttribute('data-media-id') === mediaId
          );
        });

        const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
        if (!activeMedia) return;

        activeMedia.scrollIntoView({
          block: 'nearest',
          inline: 'center'
        });

        const container = this.querySelector('[role="document"]');
        if (container) {
          const targetLeft =
            activeMedia.offsetLeft -
            Math.max((container.clientWidth - activeMedia.clientWidth) / 2, 0);

          container.scrollLeft = Math.max(targetLeft, 0);
        }

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate
          ? activeMediaTemplate.content
          : null;

        if (
          activeMedia.nodeName === 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube') &&
          typeof activeMedia.loadContent === 'function'
        ) {
          activeMedia.loadContent();
        }
      }
    }

    customElements.define('product-modal', ProductModal);
  }

  if (
    customElements.get('modal-dialog') ||
    typeof ModalDialog !== 'undefined'
  ) {
    defineProductModal();
    return;
  }

  customElements.whenDefined('modal-dialog')
    .then(() => {
      defineProductModal();
    })
    .catch(() => {});
})();